// extracted by mini-css-extract-plugin
export default {"tag-form":"tag-form_yf1VP"};